import { render, staticRenderFns } from "./UsuarioFornecedorForm.vue?vue&type=template&id=8bcadfe0&scoped=true&lang=html"
import script from "./UsuarioFornecedorForm.vue?vue&type=script&lang=js"
export * from "./UsuarioFornecedorForm.vue?vue&type=script&lang=js"
import style0 from "./UsuarioFornecedorForm.vue?vue&type=style&index=0&id=8bcadfe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcadfe0",
  null
  
)

export default component.exports